import { container, primaryColor } from "assets/jss/material-kit-react.js";

const footerStyle = theme => ({
  block: {
    color: "inherit",
    padding: "0.9375rem",
    fontWeight: "500",
    fontSize: "12px",
    textTransform: "uppercase",
    borderRadius: "3px",
    textDecoration: "none",
    position: "relative",
    display: "block"
  },
  left: {
    display: "block",
  },
  right: {
    padding: "15px 15px",
    margin: "0",
  },
  footer: {
    padding: "3rem 3rem 1rem",
    textAlign: "center",
    zIndex: "2",
    position: "relative",
    marginTop: 'auto',
    [theme.breakpoints.down('xs')]: {
      padding: '3rem 1rem 1rem'
    },
  },
  a: {
    color: primaryColor,
    textDecoration: "none",
    backgroundColor: "transparent"
  },
  footerWhiteFont: {
    "&,&:hover,&:focus": {
      color: "#FFFFFF"
    }
  },
  container: {
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center'
    },
  },
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0",
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
  },
  inlineBlock: {
    display: "inline-block",
    padding: "0px",
    width: "auto"
  },
  icon: {
    width: "18px",
    height: "18px",
    position: "relative",
    top: "3px"
  }
});
export default footerStyle;
